import { useRef, useState } from "react";
import useIsMobile from "../../../../common/hooks/useIsMobile";
import CopyUrlWeb from "./CopyUrlWeb";
import CopyUrlMobile from "./CopyUrlMobile";

const CopyUrlBox = ({ url, name }) => {
    const urlRef = useRef(null);
    const [copied, setCopied] = useState(false);
    const isMobile = useIsMobile();

    const handleCopy = () => {
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // reset icon after 2 seconds
            })
            .catch(() => {
                const range = document.createRange();
                range.selectNode(urlRef.current);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
    };

    return (
        <>
            {isMobile ? (
                <CopyUrlMobile
                    url={url}
                    name={name}
                    urlRef={urlRef}
                    copied={copied}
                    handleCopy={handleCopy}
                />
            ) : (
                <CopyUrlWeb
                    url={url}
                    name={name}
                    urlRef={urlRef}
                    copied={copied}
                    handleCopy={handleCopy}
                />
            )}
        </>
    );
};

export default CopyUrlBox;